module.exports = __webpack_public_path__ + "1edd1348fbc10ea22f360c52da53d275.MP3";